export default __webpack_public_path__ + "static/media/logo.427a2010.svg";